module.exports = __webpack_public_path__ + "img/2010 winteressen 032.18035a74.jpg";